// hrpayroll/src/pages/Profile/SecurityTab.tsx
import { useState } from "react";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useAuth } from "../../contexts/AuthContext";
import { sendPasswordOtp, changePassword } from "../../api/password";

export default function SecurityTab() {
  const { user } = useAuth();
  const email = user?.email || "";
  const [stage, setStage] = useState<"idle" | "sent">("idle");
  const [otp, setOtp] = useState("");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const sendCode = async () => {
    setBusy(true);
    try {
      await sendPasswordOtp(email);
      setStage("sent");
      toast.success(`Verification code sent to ${email}`);
    } catch (err: any) {
      toast.error(err?.message || "Could not send code");
    } finally { setBusy(false); }
  };

  const submit = async () => {
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    if (pw !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await changePassword(email, otp, pw);
      toast.success("Password updated");
      setStage("idle"); setOtp(""); setPw(""); setConfirm("");
    } catch (err: any) {
      toast.error(err?.message || "Could not update password");
    } finally { setBusy(false); }
  };

  return (
    <div className="py-4 max-w-md">
      <Card>
        <CardHeader><CardTitle className="text-base">Change password</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-gray-500">
            We'll email a 6-digit verification code to <span className="font-medium">{email}</span>. It expires in 5 minutes.
          </p>
          {stage === "idle" ? (
            <Button onClick={sendCode} disabled={busy || !email}>{busy ? "Sending…" : "Send code to my email"}</Button>
          ) : (
            <>
              <div>
                <Label className="text-xs text-gray-500">Verification code</Label>
                <Input value={otp} onChange={(e) => setOtp(e.target.value)} maxLength={6} inputMode="numeric" />
              </div>
              <div>
                <Label className="text-xs text-gray-500">New password</Label>
                <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} />
              </div>
              <div>
                <Label className="text-xs text-gray-500">Confirm new password</Label>
                <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
              </div>
              <div className="flex gap-2">
                <Button onClick={submit} disabled={busy || otp.length < 6}>{busy ? "Updating…" : "Update password"}</Button>
                <Button variant="ghost" onClick={sendCode} disabled={busy}>Resend code</Button>
              </div>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
